var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.capitalize (_vm.converted)),expression:"capitalize (converted)"}],staticClass:"Block",style:("background-color: " + (_vm.rgba ('--wc3-' + _vm.converted)) + ";" +
    "width: " + _vm.size + "px;" +
    "height: " + _vm.size + "px;")})}
var staticRenderFns = []

export { render, staticRenderFns }